"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgHeartCircle = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM8.077 8.655c1.253-1.07 2.92-.756 3.92.413 1-1.169 2.645-1.472 3.919-.413s1.429 2.86.445 4.125c-.63.81-2.243 2.314-3.322 3.29-.358.325-.538.487-.752.552a1.024 1.024 0 0 1-.58 0c-.215-.065-.394-.227-.753-.552-1.078-.976-2.692-2.48-3.322-3.29-.984-1.265-.807-3.055.445-4.125Z", fill: "currentColor" }) }))); };
exports.default = SvgHeartCircle;
